import React from "react";
import "./backgroundDots.scss"

const BackgroundDots = () => {
    let render = []
    for (let i = 0; i < 25; i++) {
        const width = Math.floor(Math.random() * 90)
        render.push(<li 
            key={i} 
            style={{
                "width": `${width}px`,
                "height": `${width}px`,
                "top": `${Math.floor(Math.random() * 90)}%`,
                "left": `${Math.floor(Math.random() * 90)}%`,
                "opacity": `${Math.random() * 0.6}`,
            }}
            >
        </li>)
    }

    return <ul className="bg">{render}</ul>
}
export default BackgroundDots;